import FormField from "./FormField";

import { combineValidators } from "ansok/components/common/CombineValidators";
import { BaseFormFieldProps } from "components/form/types";
import { validateCharacters, validateRequired } from "functions/validators";

interface FormFieldTextInputProps extends BaseFormFieldProps {
  required?: boolean
  maxLength?: number
  extraValidation?: any[]
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void
}

const FormFieldTextInput = ({ required = true, maxLength, extraValidation, ...props }: FormFieldTextInputProps) => {
  const validators = [validateCharacters]
  
  if (required) {
    validators.push(validateRequired)
  }
  
  if (extraValidation) {
    validators.push(...extraValidation)
  }
  
  return (
    <FormField
      {...props}
      maxLength={maxLength}
      validate={combineValidators(validators)}
    />
  )
};

export default FormFieldTextInput;